module.exports = __webpack_public_path__ + "static/media/app.6951d8e7.scss";


//////////////////
// WEBPACK FOOTER
// ./src/styles/app.scss
// module id = 115
// module chunks = 0